export const END_OF_DAY_FORM = 'end-of-day-form';
export const PACKING_SLIP = 'packing-slip';
export const LABEL = 'label';
export const PICK_LIST = 'pick-list';
export const HOTKEYS_AND_BARCODE = 'hotkeys-and-barcode';
export const CUSTOMS_FORM = 'customs-forms';

export const getLabelDownloadUrl = (fulfillmentIds) => `/api/download/label/${fulfillmentIds}`;
